<template>
  <div class="newsInformation maxWidth">
    <!-- banner -->
    <div class="newsInformation-banner maxWidth">
      <div class="newsInformation-bannerBox">
        <span class="edescription">{{ bannerList.alias }}</span>
        <span class="name">{{ bannerList.name }}</span>
        <span class="description">{{ bannerList.description }}</span>
      </div>
      <img :src="bannerImg" alt="" />
    </div>
    <!-- 热门资讯 -->
    <div class="popularInformation-main maxWidth">
      <div class="popularInformationInner">
        <div class="popularInformation-mainTop">
          <div class="heng"></div>
          <div class="">
            <span>热门资讯</span>
            <img src="../../assets/bigTy.png" alt="" />
          </div>
        </div>
        <div class="popularInformationBox maxWidth">
          <div class="popularInformationBoxInner">
            <div
              class="popular-mainBox"
              v-for="(item, index) in popularList.lists"
              :key="index"
              @click="zxClick(item)"
            >
              <div class="popular-mainBoxTop">
                <div class="mainBoxTop-pic">
                  <span>{{ item.cname }}</span>
                </div>
                <img :src="item.bg" alt="" />
              </div>
              <div class="popular-mainBoxBottom">
                <span>{{ item.title }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 资讯动态 -->
    <div class="informationDynamics maxWidth">
      <div class="informationDynamics-top">
        <div class="heng"></div>
        <div class="">
          <span>资讯动态</span>
          <img src="../../assets/bigTy.png" alt="" />
        </div>
      </div>
      <div class="informationDynamics-nav">
        <div class="informationDynamics-navList">
          <span
            v-for="(item, index) in typeList.lists"
            :key="index"
            :class="{ navActive: navShow == index }"
            @click="navClick(item, index)"
            >{{ item.name }}</span
          >
        </div>
      </div>
      <div class="informationDynamics-main">
        <div
          class="informationDynamics-mainBox"
          v-for="(item, index) in dynamicsList"
          :key="index"
        >
          <div class="informationDynamics-mainBoxLeft">
            <img :src="item.bg" alt="" />
          </div>
          <div class="informationDynamics-mainBoxRight">
            <div class="mainBoxRight-data">
              <span class="data">{{ item.day }} /</span>
              <div class="yearBox">
                <span>{{ item.month }} </span>
                <span class="">{{ item.year }} </span>
              </div>
            </div>
            <span class="title" @click="zxClick(item)">{{ item.title }}</span>
            <p>{{ item.description }}</p>
            <button>{{ item.cname }}</button>
          </div>
        </div>
      </div>
      <div class="informationDynamics-bottom">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="pageNo"
          :page-size="pageSize"
          layout="prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "newsInformation",
  metaInfo() {
    //设置浏览器标签页标题
    return {
      meta: [
        {
          name: "description",
          content: this.description
        }
      ]
    };
  },
  data() {
    return {
      description: "",
      bannerList: {},
      navShow: 0,
      pageid: 1,
      total: 0,
      pageSize: 6,
      pageNo: 0,
      typeList: {},
      popularList: {},
      dynamicsList: [],
      bannerImg: ""
    };
  },
  created() {
    this.getList();
    this.getItemList();
  },
  methods: {
    getList() {
      this.$axios.get("index/common/message").then(res => {
        // console.log(res);
        if (res.status == 200) {
          this.description = res.data.data.description;
          this.bannerList = res.data.data["01"];
          this.bannerImg = res.data.data["01"].banner[0].pic;
          this.popularList = res.data.data["02"];
          this.typeList = res.data.data["03"];
          document.documentElement.scrollTop = 0;
        }
      });
    },
    getItemList() {
      this.$axios
        .get("index/common/json_message", {
          params: {
            page: this.pageNo,
            limit: this.pageSize,
            pageid: this.pageid
          }
        })
        .then(res => {
          // console.log(res);
          if (res.status == 200) {
            this.dynamicsList = res.data.data;
            this.total = res.data.total;
            // document.documentElement.scrollTop =
            //   (1268 / 1920) * window.screen.availWidth;
          }
        });
    },
    navClick(item, index) {
      this.navShow = index;
      this.pageid = item.id;
      // console.log(this.pageid);
      this.pageNo = 0;
      this.getItemList();
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.pageNo = val;
      this.getItemList();
    },
    zxClick(item) {
      // console.log(item);
      this.$router.push({
        name: "newsInformationDetails",
        query: { id: item.id }
      });
    }
  }
};
</script>

<style scoped>
.maxWidth {
  max-width: 100%;
}
.newsInformation {
  width: 1920px;
  margin: 0 auto;
  margin-top: 70px;
}
.newsInformation-banner {
  width: 1920px;
  margin: 0 auto;
  position: relative;
}
.newsInformation-banner img {
  display: block;
  width: 100%;
  height: 900px;
}
.newsInformation-bannerBox {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 143px;
  left: 318px;
}
.newsInformation-bannerBox .edescription {
  width: 495px;
  font-size: 76px;
  font-family: DIN BlackAlternate;
  font-weight: 600;
  color: #454647;
  line-height: 76px;
  display: block;
  margin-bottom: 74px;
}
.newsInformation-bannerBox .name {
  font-size: 50px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #00000c;
  display: block;
  margin-bottom: 21px;
}
.newsInformation-bannerBox .description {
  width: 518px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.7);
  line-height: 28px;
  display: block;
  margin-bottom: 100px;
}
/* 热门资讯 */
.popularInformation-main {
  width: 100%;
  position: absolute;
  top: 35rem;
  left: 50%;
  transform: translateX(-50%);
}
.popularInformationInner {
}
.popularInformation-mainTop {
  width: 1280px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  position: relative;
  margin-bottom: 53px;
}
.popularInformation-mainTop .heng {
  width: 70px;
  height: 3px;
  background: #df3a3a;
  margin-bottom: 17px;
}
.popularInformation-mainTop > div span {
  font-size: 32px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #192537;
}
.popularInformation-mainTop > div img {
  display: block;
  width: 36px;
  height: 36px;
  position: absolute;
  top: 7px;
  left: 110px;
  transform: rotate(-270deg);
}

.popularInformationBox {
  width: 1920px;
  margin: 0 auto;
  background-color: #f6fafb;
}
.popularInformationBoxInner {
  display: flex;
  flex-wrap: wrap;
  width: 1280px;
  margin: 0 auto;
}
.popular-mainBox {
  width: 410px;
  height: 396px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  margin-right: 24px;
  margin-bottom: 80px;
  cursor: pointer;
}
.popular-mainBox:last-child {
  margin-right: 0;
}
.popular-mainBoxTop {
  position: relative;
}
.popular-mainBoxTop > img {
  display: block;
  width: 100%;
}
.mainBoxTop-pic {
  display: block;
  width: 133px;
  height: 44px;
  background-image: url("~../../assets/dt-icon.png");
  background-repeat: no-repeat;
  position: absolute;
  top: -1px;
  left: -1px;
  padding: 15px 25px;
}
.mainBoxTop-pic span {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #df3a3a;
}
.popular-mainBoxBottom {
  padding: 21px 31px 26px 18px;
}
.popular-mainBoxBottom span {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #2a2b33;
}
/* 资讯动态 */
.informationDynamics {
  margin-top: 370px;
}
.informationDynamics-top {
  width: 1280px;
  margin: 0 auto;
  position: relative;
  margin-bottom: 49px;
}
.informationDynamics-top .heng {
  width: 70px;
  height: 3px;
  background: #df3a3a;
  margin-bottom: 17px;
}
.informationDynamics-top > div span {
  font-size: 32px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #192537;
}
.informationDynamics-top > div img {
  display: block;
  width: 36px;
  height: 36px;
  position: absolute;
  top: 7px;
  left: 110px;
  transform: rotate(-270deg);
}
.informationDynamics-nav {
  border-bottom: 1px solid rgba(214, 219, 221, 0.4);
  margin-bottom: 42px;
}
.informationDynamics-nav .informationDynamics-navList {
  display: flex;
  justify-content: center;
}
.informationDynamics-nav .informationDynamics-navList span {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #454647;
  margin-right: 103px;
  cursor: pointer;
}
.informationDynamics-nav .informationDynamics-navList span:last-child {
  margin-right: 0;
}
.informationDynamics-nav .informationDynamics-navList .navActive {
  color: #df3a3a;
  padding-bottom: 23px;
  border-bottom: 3px solid #df3a3a;
}
.informationDynamics-main {
  width: 1280px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  margin-bottom: 60px;
}
.informationDynamics-mainBox {
  display: flex;
  padding: 42px 0;
  border-bottom: 1px solid rgba(214, 219, 221, 0.4);
}
.informationDynamics-mainBox img {
  display: block;
  width: 410px;
  height: 256px;
  margin-right: 32px;
}
.informationDynamics-mainBoxRight {
  display: flex;
  flex-direction: column;
}
.informationDynamics-mainBoxRight .title {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #2a2b33;
  display: block;
  margin-bottom: 30px;
  cursor: pointer;
}
.informationDynamics-mainBoxRight > p {
  /* width: 835px; */
  font-size: 16px;
  /* font-family: PingFang SC; */
  font-weight: 400;
  color: #595959;
  display: block;
  margin-bottom: 26px;
}
.informationDynamics-mainBoxRight > button {
  width: 100px;
  height: 34px;
  background: rgba(201, 206, 210, 0.1);
  border: 1px solid #c9ced2;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #595959;
}
.mainBoxRight-data {
  display: flex;
  align-items: center;
  margin-bottom: 25px;
}
.mainBoxRight-data .data {
  font-size: 44px;
  font-family: PingFang SC;
  font-weight: 400;
  font-style: italic;
  color: #00000c;
  margin-right: 11px;
}
.mainBoxRight-data .yearBox {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 5px;
}
.mainBoxRight-data .yearBox span {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  font-style: italic;
  color: #454647;
  display: block;
}
.mainBoxRight-data .yearBox span:first-child {
  margin-left: 7px;
}
.informationDynamics-bottom {
  text-align: center;
  margin-bottom: 190px;
}
.informationDynamics-bottom
  >>> .el-pagination.is-background
  .el-pager
  li:not(.disabled).active {
  background: linear-gradient(0deg, #dc3939, #ff4242);
}
.informationDynamics-bottom >>> .el-pagination.is-background .btn-next,
.informationDynamics-bottom >>> .el-pagination.is-background .btn-prev,
.informationDynamics-bottom >>> .el-pagination.is-background .el-pager li {
  width: 42px;
  height: 42px;
  line-height: 42px;
  border-radius: 6px;
}
</style>



// WEBPACK FOOTER //
// src/views/news/NewsInformation.vue